module.exports = __webpack_public_path__ + "img/icon_choice_close.5e98ef91.svg";